export default "__VITE_ASSET__BzDXSGxc__"